import React, { PropsWithChildren, useContext } from 'react';
import { useAsyncCallback, UseAsyncReturn } from 'react-async-hook';
import countries from '../assets/config/countries.json';
import currencies from '../assets/config/currencies.json';
import jobTitles from '../assets/config/jobTitles.json';
import accountancyPackageTypes from '../assets/config/accountancyPackageTypes.json';

type SharedContextProps = {
  listCountries: UseAsyncReturn<any, []>;
  listCurrencies: UseAsyncReturn<any, []>;
  listJobTitles: UseAsyncReturn<any, []>;
  listAccountancyPackage: UseAsyncReturn<any, []>;
};

const SharedContext = React.createContext<SharedContextProps>({} as any);

const SharedContextProvider: React.FC<PropsWithChildren<any>> = (props) => {
  const { children } = props;

  const listCountries = useAsyncCallback(async () => {
    return countries;
  });

  const listCurrencies = useAsyncCallback(async () => {
   return currencies;
  });

  const listJobTitles = useAsyncCallback(async () => {
   return jobTitles;
  });

  const listAccountancyPackage = useAsyncCallback(async () => {
    return accountancyPackageTypes;
  });


  return (
    <SharedContext.Provider
      value={{
        listCountries,
        listCurrencies,
        listJobTitles,
        listAccountancyPackage
      }}
    >
      {children}
    </SharedContext.Provider>
  );
};

export const useShared = () => useContext(SharedContext);

export default SharedContextProvider;
